import { useEffect, useLayoutEffect, useState } from 'react'
import { Autocomplete, Box, Button, CircularProgress, Grid, InputAdornment, Radio, Switch, TextField, TextareaAutosize, Typography } from '@mui/material'
import  ModalRequest  from './ModalRequest.jsx'
import { Controller, useForm } from 'react-hook-form'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { infoSelectForm, listByCountry, searchCustomDataSelect, updateInfoQuote } from 'services/quotes';
import { useSearchParams } from 'react-router-dom';
import { useAuthToken } from 'hooks/useAuthToken';

const Form = ({ text, isMobile, numPage, setCurrentBrand, children, styleButton = () => {} }) => {
  const [searchParams] = useSearchParams()
  const { handleSubmit, control, setValue } = useForm()
  const [uuidQuote, setUuidQuote] = useState()
  const [takeMedicine, setTakeMedicine] = useState(false)
  const [sensoryDeficiencies, setSensoryDeficiencies] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [country, setCountry] = useState(null)
  const [isLoad, setIsLoad] = useState(false)
  const [Load, setLoad] = useState(false)
  const [department, setDepartment] = useState([])
  const [infoSelect, setInfoSelect] = useState()
  const [searchHealth, setSearchHealth] = useState({
    search: '',
    customDataType: 0,
  });
  const [searchOcupations, setSearchOcupations] = useState({
    search: '',
    customDataType: 0,
  });
  const [open, setOpen] = useState(false)
  const [status, setStatus] = useState()
  const [message, setMessage] = useState()
  const [selectedValue, setSelectedValue] = useState({
    fallLastDays: '0',
    mentalDisorder: '0',
    antiparkinsonianos: '0',
    antidepressants: '0',
    otherMedications: '0',
    visualDisturbances: '0',
    hearingDisorders: '0',
    extremities: '0',
    inactividad: '0',
    smoking: '0',
    hypertension: '0',
    dyslipidemia: '0',
    obesity: '0',
    adultAdvanced: '0',
    familyBackground: '0',
    Diabetes: '0',
    lungDisease: '0',
    cardiovascularDisease: '0',
    renalDisease: '0',
    lossOfConsciousness: '0',
    reasonForNotDoingExercises: '0',
    musculoskeletalPresence: '0',
    surgicalProcedures: '0',
    pregnancy: '0'
  });

  const styleTextField = {
    ' .MuiOutlinedInput-root': { borderRadius: '10px' },
    width: '100%'
  }
  const label = { inputProps: { 'aria-label': 'Switch demo' } };


  const { isLoadingToken, appToken, getAuthToken } = useAuthToken();

  useLayoutEffect(() => {
    setCurrentBrand(searchParams.get("b"));
    setIsActive(searchParams.get("a") == 1);
    setUuidQuote(searchParams.get("uuid"))
    localStorage.setItem("current_brand", searchParams.get("b"));

    getAuthToken();
  }, [])

  useEffect(() => {
   const search = async () => {
    try {
      const { data } = await searchCustomDataSelect(searchHealth);
      setInfoSelect((item) => ({ ...item, 'Entidad Promotora de Salud': data.data }));
    } catch (err) {
      console.error(err);
    }
  };

  const debounceTimer = setTimeout(() => {
    search();
  }, 500);

  return () => clearTimeout(debounceTimer);
  }, [searchHealth]);

  useEffect(() => {
    const search = async () => {
      try {
        const { data } = await searchCustomDataSelect(searchOcupations);
        setInfoSelect((item) => ({ ...item, 'Ocupación': data.data }));
      } catch (err) {
        console.error(err);
      }
    };

    const debounceTimer = setTimeout(() => {
      search();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchOcupations]);

  const handleClose = () => {
    setOpen(false)
  };

  const handleChangeSelectedValue = (event, nameFields) => {
    setSelectedValue((item) => ({ ...item, [nameFields]: event.target.value }));
  };

  const onSubmit = (values) => {
    setLoad(true)
    // estructurar data
    const infoBasic = {
      'gender_identity': values?.gender?.id,
      'blood_type': values?.bloodType?.id,
      'ethnic_membership': values?.Ethnicity?.id,
      'biological_gender': values?.biologicalSex?.id
    }

    const infoResidency = {
      'city_id': values?.department?.id,
      'country_id': values?.country?.id,
      'territorial_zone': values?.territorialZone?.id,
      'phone_number': values?.phone,
      'name_emergency_contact': values?.nameEmergency,
      'phone_emergency_contact': values?.phoneEmergency,
      'relationship_emergency_contact': values?.RelationKin?.id
    }

    // esta tiene movitvo de consulta
    const infoReason = {
      'occupation': values?.occupation?.id,
      'eps': values?.HealthPromotionEntity?.id,
      // 'reason_of_query': values?.reasonForConsultation
    }

    const infoSport = {
      'sport_activity': values?.sportsPhysicalActivity?.id,
      'frecuency': values?.weeklyFrequency,
      'intensity': values?.Intensity?.name_options,
      'hour_activity': values?.hours,
      'time_activity': values?.Duration?.name_options
    }

    // esto es lo que significa cada id
    // 9 => ¿Ha tenido caídas en los últimos 12 meses?
    // 36 => ¿Su estado mental es confuso?
    // 10 => ¿Consume algún medicamento?
    // 11 => Antiparkinsonianos
    // 12 => Antidepresivos
    // 13 => Otros medicamentos
    // 14 => Deficiencias Sensoriales
    // 15 => Alteraciones visuales
    // 16 => Alteraciones auditivas
    // 35 => Extremidades (Ictus, amputación, paresia, plejía, etc)

    const infoQuestionnaireOne = [
      {"id":9, "answer": selectedValue.fallLastDays == 1 ? "SI" : "NO"},
      {"id":36, "answer": selectedValue.mentalDisorder == 1 ? "SI" : "NO"},
      {"id":10, "answer": takeMedicine == 1 ? "SI" : "NO"},
      {"id":11, "answer": selectedValue.antiparkinsonianos == 1 ? "SI" : "NO"},
      {"id":12, "answer": selectedValue.antidepressants == 1 ? "SI" : "NO"},
      {"id":13, "answer": selectedValue.otherMedications == 1 ? "SI" : "NO"},
      {"id":14, "answer": sensoryDeficiencies == 1 ? "SI" : "NO"},
      {"id":15, "answer": selectedValue.visualDisturbances == 1 ? "SI" : "NO"},
      {"id":16, "answer": selectedValue.hearingDisorders == 1 ? "SI" : "NO"},
      {"id":35, "answer": selectedValue.extremities == 1 ? "SI" : "NO"}
    ]

    // esto es lo que significa cada id
    // 17 => Sedentarismo
    // 18 => Tabaquismo
    // 19 => Hipertensión
    // 20 => Dislipidemia
    // 21 => Obesidad
    // 22 => Edad
    // 23 => Antecedente familiar
    // 25 => Diabetes
    // 26 => Enfermedad Pulmonar
    // 33 => Enfermedad Cardiovascular
    // 34 => Enfermedad Renal

    const infoQuestionnaireTwo = [
      {"id":17, "answer": selectedValue.inactividad == 1 ? "SI" : "NO"},
      {"id":18, "answer": selectedValue.smoking == 1 ? "SI" : "NO"},
      {"id":19, "answer": selectedValue.hypertension == 1 ? "SI" : "NO"},
      {"id":20, "answer": selectedValue.dyslipidemia == 1 ? "SI" : "NO"},
      {"id":21, "answer": selectedValue.obesity == 1 ? "SI" : "NO"},
      {"id":22, "answer": selectedValue.adultAdvanced == 1 ? "SI" : "NO"},
      {"id":23, "answer": selectedValue.familyBackground == 1 ? "SI" : "NO"},
      {"id":25, "answer": selectedValue.Diabetes == 1 ? "SI" : "NO"},
      {"id":26, "answer": selectedValue.lungDisease == 1 ? "SI" : "NO"},
      {"id":33, "answer": selectedValue.cardiovascularDisease == 1 ? "SI" : "NO"},
      {"id":34, "answer": selectedValue.renalDisease == 1 ? "SI" : "NO"},
    ]

    // esto es lo que significa cada id
    // 27 => Ha tenido Pérdida del conocimiento, dolor en el pecho o dificultad para respirar en el ultimo mes, palpitaciones, inflamación constante en piernas?
    // 28 => Usted tiene alguna razón por la cual no deba hacer ejercicio?
    // 29 => Presencia de dolor osteomuscular o articular que empeore con AF?
    // 31 => Procedimientos quirúrgico menor a 3 meses.
    // 32 => Embarazo

    const infoQuestionnaireThree = [
      {"survey_question_id":27, "answer": selectedValue.lossOfConsciousness == 1 ? "SI" : "NO"},
      {"survey_question_id":28, "answer": selectedValue.reasonForNotDoingExercises == 1 ? "SI" : "NO"},
      {"survey_question_id":29, "answer": selectedValue.musculoskeletalPresence == 1 ? "SI" : "NO"},
      {"survey_question_id":31, "answer": selectedValue.surgicalProcedures == 1 ? "SI" : "NO"},
      {"survey_question_id":32, "answer": selectedValue.pregnancy == 1 ? "SI" : "NO"},
    ]


    const data = {
      infoBasic,
      infoResidency,
      infoReason,
      infoSport,
      infoQuestionnaireOne,
      infoQuestionnaireTwo,
      infoQuestionnaireThree,
      'quote_id': uuidQuote
    }

    updateInfoQuote(data)
      .then(({data}) => {
        setLoad(false)
        setOpen(true)
        setStatus(data.status)
        setMessage(data.status == 'success' ? 'Formulario diligenciado' : 'Ocurrio un error')
        setTimeout(() => {
          window.location.replace("https://bodytech.com.co");
        }, 500)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  useEffect(() => {
    if (appToken && !isLoadingToken) {
      infoSelectForm()
        .then(({ data }) => {
          setInfoSelect(data.data)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => { setIsLoad(true) })
      if (country !== null) {
        listByCountry(country)
          .then(({ data }) => {
            setDepartment(data.data)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }, [appToken, isLoadingToken, country])

  return (
    <>
      {
        isLoad ? (
          <form
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* Medicina general parte 1 */}
            {numPage === 1 && (
              <Grid container width={'100%'} spacing={2}>
              {infoSelect?.['Genero biológico'] && <Grid item xs={12}>
                  <Controller
                    rules={require}
                    name="biologicalSex"
                    control={control}
                    render={({ field }) => (
                    <Autocomplete
                      {...field}
                      id="biologicalSex"
                      options={infoSelect?.['Genero biológico']}
                      getOptionLabel={(option) => option.name_options}
                      onChange={(_, value) => setValue('biologicalSex', value)}
                      renderInput={(params) => <TextField sx={styleTextField} {...params} label="Sexo biologico" />}
                    />
                    )}
                  />
                </Grid>}
                          {/*
              <Grid item xs={12}>
                <TextField  sx={{ width: '100%' }} label="Movie" type='text' {...register('pregunta')} />
              </Grid> */}
                <Grid item xs={12}>
                  <Controller
                    name="gender"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        id="gender"
                        options={infoSelect?.['Identidad de genero']}
                        getOptionLabel={(option) => option.name_options}
                        onChange={(_, value) => setValue('gender', value)}
                        renderInput={(params) => <TextField sx={styleTextField} {...params} label="Seleccionar género" />}
                      />
                    )}
                  />
                </Grid>
                <Grid item display={'flex'} justifyContent={'space-between'} xs={12}>
                  <Grid item xs={12}>
                    <Controller
                      name="bloodType"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="bloodType"
                          options={infoSelect?.['Grupo sanguineo']}
                          getOptionLabel={(option) => option.name_options}
                          onChange={(_, value) => setValue('bloodType', value)}
                          renderInput={(params) => <TextField sx={styleTextField} {...params} label="Grupo sanguineo" />}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="Ethnicity"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        id="Ethnicity"
                        options={infoSelect?.['pertenencia étnica']}
                        getOptionLabel={(option) => option.name_options}
                        onChange={(_, value) => setValue('Ethnicity', value)}
                        renderInput={(params) => <TextField sx={styleTextField} {...params} label="Pertenencia Étnica" />}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            )}

            {/* Medecina general parte 2 */}
            {
              numPage === 2 && (
                <Grid container width={'100%'} spacing={2}>
                  <Grid padding={'0'} item xs={isMobile ? 12 : 6}>
                    <Controller
                      name="country"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="country"
                          options={infoSelect?.['country']}
                          getOptionLabel={(option) => option.name}
                          onChange={(_, value) => {
                            setCountry(value.id)
                            setValue('country', value)
                          }}
                          renderInput={(params) => <TextField sx={styleTextField} {...params} label="País de residencia" />}
                        />
                      )}
                    />
                  </Grid>
                  {
                    department.length > 0 && (
                      <Grid item xs={isMobile ? 12 : 6}>
                        <Controller
                          name="department"
                          control={control}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              id="department"
                              options={department}
                              getOptionLabel={(option) => option.name}
                              onChange={(_, value) => setValue('department', value)}
                              renderInput={(params) => <TextField sx={styleTextField} {...params} label="Departamento" />}
                            />
                          )}
                        />
                      </Grid>
                    )
                  }
                  <Grid item xs={isMobile ? 12 : 6}>
                    <Controller
                      name="territorialZone"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="territorialZone"
                          options={infoSelect?.['zona territorial']}
                          getOptionLabel={(option) => option.name_options}
                          onChange={(_, value) => setValue('territorialZone', value)}
                          renderInput={(params) => <TextField sx={styleTextField} {...params} label="Zona territorial" />}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6}>
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="phone"
                          sx={{ width: '100%' }}
                          label="Teléfono"
                          type='text'
                          onChange={(e) => setValue('phone', e.target.value)}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={{ color: '#6D6D6C' }} variant="text" gutterBottom>
                      Contactos de emergencias
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="nameEmergency"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="nameEmergency"
                          sx={{ width: '100%' }}
                          label="Nombre Contacto de emergencia"
                          type='text'
                          onChange={(e) => setValue('nameEmergency', e.target.value)}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6}>
                    <Controller
                      name="phoneEmergency"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="phoneEmergency"
                          sx={{ width: '100%' }}
                          label="Número de teléfono"
                          type='text'
                          onChange={(e) => setValue('phoneEmergency', e.target.value)}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6}>
                    <Controller
                      name="RelationKin"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="RelationKin"
                          options={infoSelect?.['Parentesco']}
                          getOptionLabel={(option) => option.name_options}
                          onChange={(_, value) => setValue('RelationKin', value)}
                          renderInput={(params) => <TextField sx={styleTextField} {...params} label="Parentesco" />}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              )
            }

            {/* Medicina general parte 3 */}
            {
              numPage === 3 && (
                <Grid container width={'100%'} spacing={2}>
                  <Grid item xs={12}>
                    <Controller
                      name="occupation"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="occupation"
                          options={infoSelect?.['Ocupación']}
                          getOptionLabel={(option) => option.name_options}
                          onChange={(_, value) => setValue('occupation', value)}
                          renderInput={(params) =>
                            <TextField
                              sx={styleTextField}
                              {...params}
                              label="Ocupación"
                              onChange={({target}) => {
                                setSearchOcupations((item) => ({ ...item, search: target.value, customDataType: 3 }))
                              }}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="HealthPromotionEntity"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          id="HealthPromotionEntity"
                          options={infoSelect?.['Entidad Promotora de Salud']}
                          getOptionLabel={(option) => option.name_options}
                          onChange={(_, value) => setValue('HealthPromotionEntity', value)}
                          renderInput={(params) =>
                            <TextField
                              sx={styleTextField}
                              {...params}
                              label="Entidad promotora de salud"
                              onChange={({target}) => {
                                setSearchHealth((item) => ({ ...item, search: target.value, customDataType: 36 }))
                              }}
                            />
                          }
                        />
                      )}
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <Typography sx={{ color: '#6D6D6C' }} variant="text" gutterBottom>
                      Motivo de consulta
                    </Typography>
                  </Grid> */}
                  {/* <Grid item xs={12}>
                    <Controller
                      name="reasonForConsultation"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          id="reasonForConsultation"
                          label="Motivo de consulta"
                          style={{ width: '100%' }}
                          onChange={(e) => setValue('reasonForConsultation', e.target.value)}
                        />
                      )}
                    />
                  </Grid> */}
                </Grid>
              )
            }
            {/* Riesgo cardiovascular parte 1 */}
            {
              numPage === 4 && (
                <Grid container width={'100%'} spacing={2} display={'flex'} justifyContent={'flex-end'}>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        No
                      </Typography>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        Si
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Ha tenido caídas en los últimos 12 meses
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.fallLastDays === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'fallLastDays')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.fallLastDays === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'fallLastDays')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Presenta alguna alteración de su estado mental?
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.mentalDisorder === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'mentalDisorder')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.mentalDisorder === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'mentalDisorder')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'space-between'}>
                    <Grid item xs={6}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Consume algún medicamento?
                      </Typography>
                    </Grid>
                    <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                      <Switch onChange={(e) => setTakeMedicine(e.target.checked)} {...label} />
                    </Grid>
                  </Grid>
                  {takeMedicine && (
                    <>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                            No
                          </Typography>
                          <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                            Si
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Antiparkinsonianos
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.antiparkinsonianos === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'antiparkinsonianos')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.antiparkinsonianos === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'antiparkinsonianos')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Antidepresivos
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.antidepressants === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'antidepressants')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.antidepressants === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'antidepressants')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Otros medicamentos
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.otherMedications === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'otherMedications')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.otherMedications === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'otherMedications')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} display={'flex'} justifyContent={'space-between'}>
                    <Grid item xs={6}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Deficiencias Sensoriales
                      </Typography>
                    </Grid>
                    <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                      <Switch onChange={(e) => setSensoryDeficiencies(e.target.checked)} {...label} />
                    </Grid>
                  </Grid>
                  {sensoryDeficiencies && (
                    <>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                            No
                          </Typography>
                          <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                            Si
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Alteraciones visuales
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.visualDisturbances === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'visualDisturbances')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.visualDisturbances === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'visualDisturbances')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Alteraciones auditivas
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.hearingDisorders === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'hearingDisorders')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.hearingDisorders === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'hearingDisorders')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                        <Grid item xs={9}>
                          <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                            Extremidades (Ictus, amputación, paresia, plejía, etc)
                          </Typography>
                        </Grid>
                        <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                          <Radio
                            checked={selectedValue.extremities === '0'}
                            onChange={(e) => handleChangeSelectedValue(e, 'extremities')}
                            value={'0'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '0' }}
                          />
                          <Radio
                            checked={selectedValue.extremities === '1'}
                            onChange={(e) => handleChangeSelectedValue(e, 'extremities')}
                            value={'1'}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': '1' }}
                          />
                        </Grid>
                      </Grid>

                    </>
                  )}
                </Grid>
              )
            }

            {/* Riesgo cardiovascular parte 2 */}
            {
              numPage === 5 && (
                <Grid container width={'100%'} spacing={2} display={'flex'} justifyContent={'flex-end'}>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        No
                      </Typography>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        Si
                      </Typography>
                    </Grid>
                  </Grid>
                  {!isMobile && (
                    <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                      <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                        <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                          No
                        </Typography>
                        <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                          Si
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Sedentarismo (menos de 150 min de actividad física a la semana)
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.inactividad === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'inactividad')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.inactividad === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'inactividad')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Tabaquismo
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.smoking === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'smoking')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.smoking === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'smoking')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Hipertensión
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.hypertension === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'hypertension')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.hypertension === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'hypertension')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Dislipidemia
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.dyslipidemia === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'dyslipidemia')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.dyslipidemia === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'dyslipidemia')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Obesidad
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.obesity === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'obesity')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.obesity === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'obesity')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Es un hombre mayor de 45 años o una mujer mayor de 55 años?
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.adultAdvanced === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'adultAdvanced')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.adultAdvanced === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'adultAdvanced')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Antecedente familiar (Enfermedades cardiovasculares en menores de 55 años y primer grado de consanguiniedad)
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.familyBackground === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'familyBackground')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.familyBackground === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'familyBackground')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Diabetes
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.Diabetes === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'Diabetes')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.Diabetes === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'Diabetes')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Enfermedad Pulmonar
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.lungDisease === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'lungDisease')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.lungDisease === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'lungDisease')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Enfermedad Cardiovascular
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.cardiovascularDisease === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'cardiovascularDisease')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.cardiovascularDisease === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'cardiovascularDisease')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={isMobile ? 12 : 6} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Enfermedad Renal
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.renalDisease === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'renalDisease')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.renalDisease === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'renalDisease')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )
            }

            {/* Riesgo cardiovascular parte 2 */}
            {
              numPage === 6 && (
                <Grid container width={'100%'} spacing={2} display={'flex'} justifyContent={'flex-end'}>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        No
                      </Typography>
                      <Typography sx={{ color: '#3C3C3B', width: '42px', textAlign: 'center' }} variant="text" gutterBottom>
                        Si
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Ha tenido Pérdida del conocimiento, dolor en el pecho o dificultad para respirar en el ultimo mes, palpitaciones, inflamación constante en piernas?
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.lossOfConsciousness === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'lossOfConsciousness')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.lossOfConsciousness === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'lossOfConsciousness')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Usted tiene alguna razón por la cual no deba hacer ejercicio?
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.reasonForNotDoingExercises === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'reasonForNotDoingExercises')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.reasonForNotDoingExercises === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'reasonForNotDoingExercises')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Presencia de dolor osteomuscular o articular que empeore con actividad física?
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.musculoskeletalPresence === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'musculoskeletalPresence')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.musculoskeletalPresence === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'musculoskeletalPresence')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Procedimientos quirúrgico menor a 3 meses.
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.surgicalProcedures === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'surgicalProcedures')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.surgicalProcedures === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'surgicalProcedures')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
                    <Grid item xs={9}>
                      <Typography sx={{ color: '#3C3C3B' }} variant="text" gutterBottom>
                        Embarazo
                      </Typography>
                    </Grid>
                    <Grid item xs={3} display={'flex'} justifyContent={'space-between'}>
                      <Radio
                        checked={selectedValue.pregnancy === '0'}
                        onChange={(e) => handleChangeSelectedValue(e, 'pregnancy')}
                        value={'0'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '0' }}
                      />
                      <Radio
                        checked={selectedValue.pregnancy === '1'}
                        onChange={(e) => handleChangeSelectedValue(e, 'pregnancy')}
                        value={'1'}
                        name="radio-buttons"
                        inputProps={{ 'aria-label': '1' }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )
            }
            { !Load ? (children) : (
              <Box display={'flex'} justifyContent={'center'} width={'100%'} marginTop={'20px'}>
                <CircularProgress />
              </Box>
            )}

            <ModalRequest
              isMobile={isMobile}
              styleButton={styleButton}
              open={open}
              handleClose={handleClose}
              text={message}
              status={status}
            />
          </form >
        ) : (
          <Box display={'flex'} justifyContent={'center'} width={'100%'}>
            <CircularProgress />
          </Box>
        )
      }
    </>


  )
}

export default Form
